import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, Col, Form, Row } from "react-bootstrap";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import { AdminSectionSettingsService } from "./service";
import { InitEditorMulti } from "../../shared/tinyMce/InitEditorMulti";
import { ISectionSettings } from "./interface";
import RichTextEditor from "../../shared/editor/RichTextEditor";

const SectionSettings = () => {
  const { t } = useTranslation();
  const [state, setState] = useState<ISectionSettings | undefined>(undefined);
  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setState(
      (prevState) => ({ ...prevState, [name]: value }) as ISectionSettings
    );
  };
  const handleText = (text: string) => {
    setState((prevState) => ({ ...prevState, text }) as ISectionSettings);
  };
  const submitHandler = () => {
    state &&
      AdminSectionSettingsService.create(state)
        .then((response) => {
          SuccessToast(t(`sections.successfully_updated_settings`));
          setState(response.data);
        })
        .catch(ErrorToast);
  };

  useEffect(() => {
    AdminSectionSettingsService.get()
      .then((response) => {
        const { data } = response;
        setState(data);
        InitEditorMulti(data?.text ?? "", handleText, ".text");
      })
      .catch(ErrorToast);
  }, []);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        submitHandler();
      }}
    >
      <Card>
        <Card.Body>
          <Row>
            <Col md={6} className="mt-2">
              <label>{t("global.title")}</label>
              <input
                name="title"
                type="text"
                className="form-control"
                onChange={changeHandler}
                value={state?.title}
              />
            </Col>
            <Col md={6} className="mt-2">
              <label>{t("global.subtitle")}</label>
              <input
                name="subTitle"
                type="text"
                className="form-control"
                onChange={changeHandler}
                value={state?.subTitle}
              />
            </Col>
            <Col md={6} className="mt-2">
              <label>{t("global.link")} 1</label>
              <input
                name="link"
                type="text"
                className="form-control"
                onChange={changeHandler}
                value={state?.link}
              />
            </Col>
            <Col md={6} className="mt-2">
              <label>{t("global.button_text")} 1</label>
              <input
                name="buttonTitle"
                type="text"
                className="form-control"
                onChange={changeHandler}
                value={state?.buttonTitle}
              />
            </Col>
            <Col md={6} className="mt-2">
              <label>{t("global.link")} 2</label>
              <input
                name="link2"
                type="text"
                className="form-control"
                onChange={changeHandler}
                value={state?.link2}
              />
            </Col>
            <Col md={6} className="mt-2">
              <label>{t("global.button_text")} 2</label>
              <input
                name="buttonTitle2"
                type="text"
                className="form-control"
                onChange={changeHandler}
                value={state?.buttonTitle2}
              />
            </Col>
            <Col md={12} className="my-3" id="custom-editor">
              <RichTextEditor
                label={t("global.text")}
                value={state?.text ?? ""}
                onChange={(newContent) =>
                  setState((prev: any) => ({
                    ...prev,
                    text: newContent,
                  }))
                }
              />

              {/* <label htmlFor="title" className="required-field">
                                {t("global.text")}
                            </label>
                            <textarea className="editor text"/> */}
            </Col>
          </Row>
          <div className="col-12 mt-5 d-flex justify-content-end">
            <button className="btn btn-primary ms-3" type={"submit"}>
              {t("global.save")}
            </button>
          </div>
        </Card.Body>
      </Card>
    </Form>
  );
};

export default SectionSettings;
